import React from 'react';
import { DismissRegular } from '@fluentui/react-icons';
import {
    MessageBar,
    MessageBarActions,
    MessageBarBody,
    MessageBarTitle,
    Button,
    Tooltip,
} from '@fluentui/react-components';
import { useSelector } from 'react-redux';
import { RootState } from '../../utils/store';

interface ContextPromptProps {
    onDone: (proceed: boolean) => void;
}

const ContextPrompt: React.FC<ContextPromptProps> = ({ onDone }) => {
    const settings = useSelector((state: RootState) => state.settings);
    const isDisabled = Object.keys(settings.context).length === 0;

    return (
        <MessageBar
            intent="success"
            style={{ padding: '12px', opacity: '0.7' }}
        >
            <MessageBarBody>
                <MessageBarTitle>Next Steps:</MessageBarTitle>
                Waiting for you to provide context for the above items. Let me
                know once you are done!
            </MessageBarBody>
            <MessageBarActions
                containerAction={
                    <Button
                        appearance="transparent"
                        icon={<DismissRegular />}
                        onClick={() => onDone(false)}
                    />
                }
            >
                {isDisabled ? (
                    <Tooltip
                        content="Click on a link above, or the Add Context button below."
                        relationship="label"
                    >
                        <Button
                            onClick={() => onDone(true)}
                            disabled={isDisabled}
                            disabledFocusable={isDisabled}
                        >
                            Done
                        </Button>
                    </Tooltip>
                ) : (
                    <Button
                        onClick={() => onDone(true)}
                        disabled={isDisabled}
                        disabledFocusable={isDisabled}
                    >
                        Done
                    </Button>
                )}
            </MessageBarActions>
        </MessageBar>
    );
};

export default ContextPrompt;
